import { ReactNode } from "react";
import { AccessDeniedPage } from "@/features/auth/pages/AccessDeniedPage";
import { CenteredSpinner } from "@/shared/components/centeredSpinner";
import { useFeatureVisibility } from "@/shared/hooks/useAppSettings";

type HiddenFeature =
  | "service_deals"
  | "service_refunds"
  | "service_sponsorship"
  | "service_catalog"
  | "service_classifieds";

type OrganizationRouteGuardProps = {
  children: ReactNode
  hiddenFeature: HiddenFeature
  fallback?: ReactNode
};

export const OrganizationRouteGuard = ({ children, hiddenFeature, fallback }: OrganizationRouteGuardProps) => {
  const { isHidden, isPending } = useFeatureVisibility(hiddenFeature);

  if (isPending) {
    return <CenteredSpinner />;
  }

  if (isHidden) {
    return fallback ?? <AccessDeniedPage />;
  }

  return <>{children}</>;
};
